module.exports = __webpack_public_path__ + "static/media/frank.50fd7046.png";